(function ($, Global) {
    var timer;
    var RecapPage = function (recapModel) {
        this.recapModel = recapModel;
    };

    RecapPage.prototype.initEvents = function () {
        this.publishers()
    }

    RecapPage.prototype.publishers = function () {
        $(document).ready(function () {
            $('.item-rubrique').on('click', function (e) {
                var $this = $(this);
                var url = $this.data('url');
                var state = $this.hasClass('subscribed');

                if (!state) return Global.location.replace(url);

                $this.addClass('in');
                clearTimeout(timer);
                timer = setTimeout(function () {
                    $('.item-rubrique').removeClass('in');
                }, 3000);
            });
        });
    }

    Global.RecapPage = RecapPage
}(jQuery, window));